import * as types from './types';
import { AuthState } from './interface';
import { authInitialState } from './initialState';

export default function reducer(state: AuthState = authInitialState, action: any) {
  switch(action.type) {
    case types.LOGIN_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case types.LOGIN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        user: action.payload,
        didLogin: true,
      };
    }

    case types.LOGIN_ERROR:
    case types.REGISTER_ERROR: {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload
      }
    }
    
    case types.SHOW_CONFIRM_EMAIL: {
      return {
        ...state,
        showConfirmEmail: action.payload
      }
    }

    case types.LOGOUT: {
      return {
        isLoading: false,
        user: null,
        session: null
      }
    }

    case types.REGISTER_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case types.REGISTER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        showConfirmRegister: true,
        user: action.payload
      };
    }

    case types.CONFIRM_REGISTER_START: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case types.CONFIRM_REGISTER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        showConfirmRegister: false,
        didRegister: true,
      };
    }

    case types.RESET_PASSWORD_REQUEST_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case types.RESET_PASSWORD_REQUEST_SUCCESS: {
      return {
        ...state,
        isLoading: true,
        showConfirmResetPassword: true
      };
    }
    case types.RESET_PASSWORD_REQUEST_ERROR: {
      return {
        ...state,
        loadingError: action.payload
      };
    }

    case types.STORE_SESSION: {
      return {
        ...state,
        isLoading: false,
        session: action.payload,
        // didRegister: false,
        // didLogin: false,
      }
    }
    case types.SET_USER: {
      return {
        ...state,
        isLoading: false,
        user: action.payload
      }
    }
    
    case types.GET_ISSUER_START: {
      return {
        ...state,
        isLoading: true
      };
    }
    case types.GET_ISSUER_ERROR: {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
      };
    }
    case types.GET_ISSUER_SUCCESS ||
      types.UPDATE_ISSUER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        issuer: action.payload
      };
    }

    default: {
        return state;
    }
  }
}